import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import { partners } from '../data/mock';

const PartnerCard = ({ p, idx }) => {
  const isStar = p.star;
  const hasPage = Boolean(p.link);
  const CardTag = hasPage ? Link : 'a';
  const cardProps = hasPage ? { to: p.link } : { href: `#${p.id}` };

  return (
    <CardTag
      {...cardProps}
      className={`group relative rounded-2xl p-7 border-2 btn-transition ${
        isStar
          ? 'bg-white shadow-lg hover:shadow-2xl hover:-translate-y-1'
          : 'bg-white border-slate-100 hover:border-[#0A2A63] hover:shadow-2xl'
      }`}
      style={isStar ? { borderColor: p.accent } : undefined}
    >
      {/* Star badge */}
      {isStar && (
        <div
          className="absolute -top-3 left-5 z-10 inline-flex items-center gap-1 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest text-white shadow-lg whitespace-nowrap leading-none"
          style={{ backgroundColor: p.accent }}
        >
          <Sparkles className="h-3 w-3 shrink-0" />
          <span>Star</span>
        </div>
      )}

      {/* Colored top accent line for stars */}
      {isStar && (
        <div className="absolute top-0 left-6 right-6 h-1 rounded-full" style={{ backgroundColor: p.accent }} />
      )}

      <div className="h-20 flex items-center justify-start mb-6">
        <img
          src={p.logo}
          alt={p.name}
          className="max-h-16 max-w-[180px] object-contain transition-all"
        />
      </div>
      <h3 className="text-xl font-bold text-[#050F2E] mb-2">{p.name}</h3>
      <p className="text-sm text-slate-600 leading-relaxed mb-6">{p.description}</p>
      <div
        className="inline-flex items-center gap-1 text-sm font-bold group-hover:translate-x-0.5 transition-transform"
        style={{ color: isStar ? p.accent : '#0A2A63' }}
      >
        {isStar ? 'Explore' : 'Learn more'}
        <ArrowUpRight className="h-4 w-4" />
      </div>

      {/* Floating index */}
      <span
        className="absolute top-5 right-5 text-xs font-mono"
        style={{ color: isStar ? p.accent + 'AA' : '#cbd5e1' }}
      >
        0{idx + 1}
      </span>
    </CardTag>
  );
};

const PartnersGrid = () => {
  // Sort: star products first
  const sorted = [...partners].sort((a, b) => (b.star ? 1 : 0) - (a.star ? 1 : 0));

  return (
    <section className="py-24 bg-slate-50/60 border-y border-slate-100" data-testid="partners-grid-section">
      <div className="container-pn">
        <div className="max-w-3xl mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-3">Our Brand Partners</p>
          <h2 className="text-4xl md:text-5xl font-black text-[#050F2E] tracking-tight">
            Industry-leading <span className="text-[#0A2A63]">solutions</span>
          </h2>
          <p className="mt-3 text-slate-600">
            <span className="inline-flex items-center gap-1.5 text-[#FF4E50] font-bold text-sm">
              <Sparkles className="h-3.5 w-3.5" />
            </span>{' '}
            marked with a star are our flagship solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {sorted.map((p, idx) => (
            <PartnerCard key={p.id} p={p} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersGrid;
